import { GlobalAxios } from "../axios/axios-config";
import { IAccessControlVisitorSendsLog } from "../models/access-control-visitor-sends-log";

const ACCESS_CONTROL_VISITOR_SEND_LOG_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/AccessControlVisitorSendsLog/AccessControlVisitorSendsLogs";

export const getAccessControlVisitorSendsLog = (
  accessControlVisitorSendsIdentifier: number,
) => {
  return GlobalAxios.get<IAccessControlVisitorSendsLog>(
    ACCESS_CONTROL_VISITOR_SEND_LOG_ROUTE,
    {
      params: {
        accessControlVisitorSendsIdentifier,
      },
    },
  );
};
